module.exports = __webpack_public_path__ + "img/premium-tag-03-cs.54b053bb.svg";